import { useState, useEffect } from 'react';

import Webcam from './components/Webcam';


function Webcams() {

  return (
    <div className='mt-3'>

      <h2 className='text-center mb-3 text-secondary'>OT Webcams</h2>

      {/* ---- Common OT Webcams ------ */}
{/* 
      <h5>General views</h5>

      <div className="row gx-1" style={{margin: '0 auto'}}>
        <div className="col-md-3 col-sm-6">
            <Webcam webcamUrl="https://cww.ot-admin.net/webcam/ot-north.jpg" title="North" />
        </div>
        <div className="col-md-3 col-sm-6">
            <Webcam webcamUrl="https://cww.ot-admin.net/webcam/ot-east.jpg" title="East"  />
        </div>
        <div className="col-md-3 col-sm-6">
            <Webcam webcamUrl="https://cww.ot-admin.net/webcam/ot-south.jpg" title="South"  />
        </div>
        <div className="col-md-3 col-sm-6 ">
            <Webcam webcamUrl="https://cww.ot-admin.net/webcam/ot-west.jpg" title="West"  />
        </div>
      </div>
    <hr></hr>

 */}

    {/* ---- SONG Cameras ------ */}
    <h5>SONG</h5>

    <div className="row gx-1" style={{margin: '0 auto'}}>

        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="http://song.phys.au.dk/tenerife/webcams/ot_cam_1_image.php" title="SONG webcam 1, W-SW view" />
        </div>
        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="http://song.phys.au.dk/tenerife/webcams/ot_cam_2_image.php" title="SONG webcam 2, NW-W view"  />
        </div>
        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="http://song.phys.au.dk/tenerife/webcams/ot_cam_5_image.php" title="SONG webcam 5, S-SW view"  />
        </div>
    </div>

    <hr></hr>

    {/* ---- SPECULOOS------ */}

    <h5>SPECULOOS-N</h5>

    <div style={{margin: '20px auto'}} className='text-center'>
      {/* Esta image se descarga por cron en OOCC desde 
        http://www2.exotic.uliege.be/SPECULOOS-N/OT/AllSkyCurrentImage.JPG
        para evitar el problema de http
      */}
      <Webcam webcamUrl="https://research.iac.es/OOCC/tiempo/speculoos_allsky/AllSkyCurrentImage.JPG" title="SPECULOOS-N"  />
    </div>

    <hr></hr>

    <h5>AEMET/CIAI</h5>

    <div className="row gx-1 my-4" style={{margin: '0 auto'}}>
        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="https://izana.aemet.es/wp-content/rtime/camaras/north.jpg" title="North view from CIAI" />
        </div>
        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="https://izana.aemet.es/wp-content/rtime/camaras/guimar.jpg" title="East (Güimar) view from CIAI"  />
        </div>
        <div className="col-md-4 col-sm-6">
            <Webcam webcamUrl="https://izana.aemet.es/wp-content/rtime/camaras/south.jpg" title="South view from CIAI"  />
        </div>
    </div>

    <div className="row gx-1 mb-4" style={{margin: '0 auto'}}>
        <div className="col-md-6 col-sm-6">
            <Webcam webcamUrl="https://izana.aemet.es/wp-content/rtime/camaras/sona_dia.jpg" title="CIAI day allsky 07:00-19:00 UTC" />
        </div>
        <div className="col-md-6 col-sm-6">
            <Webcam webcamUrl="https://izana.aemet.es/wp-content/rtime/camaras/sona_noche.jpg" title="CIAI night allsky 19:00-05:00 UTC" />
        </div>
    </div>

    <p className='text-end'><a target='_blank' title='Webcams in the The Izaña Atmospheric Research Center (CIAI) at Izáña' href='https://izana.aemet.es/webcams-3/'>AEMET/CIAI webcams</a></p>

  </div>

  );

}

export default Webcams;